import './errorBoundaryFallback.less';
import strings from 'mobile_web/strings';

export function ErrorBoundaryFallback() {
	return (
		<div className="error-boundary-fallback">
			<div className="error-boundary-fallback__content">
				<div className="error-boundary-fallback__icon">
					<i className="fa-solid fa-triangle-exclamation" />
				</div>
				<div className="error-boundary-fallback__title">{strings.error_boundary_fallback_title}</div>
				<div className="error-boundary-fallback__description">{strings.error_boundary_fallback_refresh}</div>
			</div>
		</div>
	);
}
